import * as S from './CurrentHotelImage.styles';

const CurrentHotelImage: React.FC<{
  imageSrc: string;
}> = ({imageSrc}) => {
  return (
    <S.HotelImageWrapDiv data-nosnippet>
      <S.HotelGalleryImage
        src={
          imageSrc ||
          'https://cdn1.goibibo.com/image/fetch/t_g/f_webp/https://gos3.ibcdn.com/3a51fc529d5b11e99b9d0242ac110007.jpg'
        }
        alt="current hotel"
      />
    </S.HotelImageWrapDiv>
  );
};

export default CurrentHotelImage;
